import React, { Fragment, useEffect } from 'react'
import { useLocation } from '@reach/router'
import { openChat } from '../../utils/utils'

export function HandleOpenChat() {
  const routerLocation = useLocation()

  useEffect(() => {
    if (routerLocation.hash === '#chat') {
      openChat()

      // remove hash #chat
      window.history.pushState(null, '', routerLocation.pathname)
    }
  }, [routerLocation])

  return <Fragment />
}
